export const FeatureFlags = {
  BULK_UPDATE_ENABLED: 'bulk_updates_enabled',
  REMOVE_OPERATIONS_ENABLED: 'remove_ops_enabled',
  PATCH_EDIT_ENABLED: 'patch_edit_enabled',
} as const;

export type FeatureFlagKey = typeof FeatureFlags[keyof typeof FeatureFlags];

export function isValidFeatureFlag(key: string): key is FeatureFlagKey {
  return Object.values(FeatureFlags).includes(key as FeatureFlagKey);
}

export default FeatureFlags;
